import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ClinicLayout from "../ClinicLayout";
import ClubPortalBrandingActivator from "../ClubPortalBrandingActivator";
import AdminPatientsRoutes from "../AdminPatients";
import AdminJournal from "../AdminJournal";
import AdminGroups from "../AdminGroups";
import AdminClubLife from "../AdminClubLife";
import AdminPolls from "../AdminPolls";
import TrainerCalendar from "../AdminSchedule/TrainerCalendar";
import StaffAppShell from "./StaffAppShell";
import StaffAppMore from "./StaffAppMore";
import StaffOverview from "./StaffOverview";
import StaffProfile from "./StaffProfile";
import AdminChatRoutes from "../AdminPortal/AdminChatRoutes";
import AdminNotifications from "../AdminNotifications";
import { useStaffAppMode } from "../../../hooks/useAdminAppMode";
import {
  redirectForStaffRoute,
  resolveStaffTabId,
} from "../../../utils/staffNav";
import L from "../../../constants/baysportLabels";
import { ToastProvider } from "../../ui";

function StaffDashboardContent({ appMode = false }) {
  const location = useLocation();
  const { tenant } = useSelector((state) => state.auth);
  const tab = resolveStaffTabId(location.pathname);

  const hiddenRedirect = redirectForStaffRoute(location.pathname);
  if (hiddenRedirect) {
    return <Navigate to={hiddenRedirect} replace />;
  }

  return (
    <>
      {tab === "overview" && <StaffOverview appMode={appMode} />}
      {tab === "more" && <StaffAppMore />}
      {tab === "chat" && <AdminChatRoutes />}
      {tab === "profile" && (
        <Routes>
          <Route path="profile/*" element={<StaffProfile />} />
        </Routes>
      )}
      {tab === "schedule" && <TrainerCalendar staffMode />}
      {tab === "journal" && <AdminJournal staffMode />}
      {tab === "groups" && <AdminGroups staffMode />}
      {tab === "life" && <AdminClubLife />}
      {tab === "polls" && <AdminPolls />}
      {tab === "notifications" && (
        <AdminNotifications hubBase="/staff/app" />
      )}
      {tab === "clients" && (
        <Routes>
          <Route path="clients/*" element={<AdminPatientsRoutes staffMode />} />
        </Routes>
      )}
    </>
  );
}

export default function StaffTrainerPortal() {
  const appMode = useStaffAppMode();
  const { tenant } = useSelector((state) => state.auth);

  const content = (
    <>
      <ClubPortalBrandingActivator />
      <StaffDashboardContent appMode={appMode} />
    </>
  );

  if (appMode) {
    return (
      <ToastProvider>
        <StaffAppShell>{content}</StaffAppShell>
      </ToastProvider>
    );
  }

  return (
    <ClinicLayout title={L.trainer} subtitle="Расписание, журнал и клиенты">
      {content}
    </ClinicLayout>
  );
}
